<!-- タイトルと新規作成ボタン -->
<div class="title-area">
  <h2 class="title">組合相談</h2>
  <button mat-raised-button color="warn" [disabled]="showSpinner" (click)="onCreate()">
    新規作成
  </button>
</div>

<!-- スピナー -->
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <table class="list-table">
    <thead>
      <tr>
        <th class="col-status">ステータス</th>
        <th class="col-result">結果</th>
        <th class="col-content">相談内容</th>
        <th class="col-consultant">相談者</th>
        <th class="col-urgency">緊急度</th>
        <th class="col-scope">共有範囲</th>
        <th class="col-dates">相談日など</th>
      </tr>
    </thead>
    <tbody>
      @for (item of items; track item.id) {
        <tr>
          <!-- ステータス -->
          <td class="col-status">
            <div class="cell-center">{{ item.status }}</div>
          </td>

          <!-- 結果 -->
          <td class="col-result">
            <div class="cell-center">
              @if (item.resultType) {
                {{ item.resultType }}
              }
            </div>
          </td>

          <!-- 相談内容 -->
          <td class="col-content">
            <div class="content-area">
              <a class="content-title" (click)="onItemClick(item)">{{ item.title }}</a>
              @if (item.categoryNames?.length) {
                <div class="category-tags">
                  @for (name of item.categoryNames; track $index) {
                    <span class="category-tag">{{ name }}</span>
                  }
                </div>
              }
              <div class="content-summary">{{ getTruncatedSummary(item.summary) }}</div>
            </div>
          </td>

          <!-- 相談者 -->
          <td class="col-consultant">
            <div class="consultant-area">
              @for (path of item.consultantAffiliation; track $index) {
                <div class="consultant-affiliation">{{ path }}</div>
              }
              <div class="consultant-name">{{ item.consultantName }}</div>
              <div class="consultant-meta">{{ item.consultantAgeGroup }} {{ item.consultantGender }}</div>
            </div>
          </td>

          <!-- 緊急度 -->
          <td class="col-urgency">
            <div class="cell-center">{{ item.urgency }}</div>
          </td>

          <!-- 共有範囲 -->
          <td class="col-scope">
            <div class="scope-area">
              <div>自組織</div>
              <div>管理以上</div>
              @if (item.additionalMembers?.length) {
                <div>他{{ item.additionalMembers.length }}名</div>
              }
            </div>
          </td>

          <!-- 相談日など -->
          <td class="col-dates">
            <div class="dates-area">
              @if (item.consultDates?.length) {
                <div class="consult-dates">{{ getDisplayConsultDates(item.consultDates) }}</div>
              }
              @if (item.updatedAt) {
                <div class="last-updated">
                  <span class="last-updated-label">最終更新日</span>
                  <span class="last-updated-date">{{ item.updatedAt | date:'yyyy/MM/dd' }}</span>
                </div>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>

  @if (items.length === 0) {
    <div class="no-items">相談がありません。</div>
  }
}
